var r = /* @__PURE__ */ ((e) => (e.UserContextKey = "sio_u_public", e.BrowserSessionActiveId = "sio_browser_session_active_id", e))(r || {});
export {
  r as CookiesEnum
};
